import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Check, Pencil, Trash2, X } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";

const ACTIVE = ["new", "in_progress"];

// أزرار بطاقة المهمة: تقدّم/إكمال للمكلّف، اعتماد/رفض/تعديل/حذف للمدير — محكومة بالحالة.
export const TaskCardActions = ({ task, mine, canManage, onProgress, onComplete, onApprove, onReject, onEdit, onDelete }) => {
  const { t } = useTranslation();
  const [p, setP] = useState(task.progress);
  const editable = ACTIVE.includes(task.status);
  const canWork = mine || canManage;
  const btn = "flex items-center gap-1 px-3 py-1.5 text-base font-bold sm:text-xs";
  return (
    <div className="mt-4 grid gap-2">
      {editable && canWork ? (
        <div className="flex items-center gap-2" data-testid={`task-progress-${task.id}`}>
          <input type="range" min="0" max="100" step="5" value={p} onChange={(e) => setP(Number(e.target.value))}
                 className="h-2 flex-1 accent-primary" data-testid={`task-progress-range-${task.id}`} />
          <span className="num w-9 text-base font-black sm:text-xs">{p}%</span>
          <NeuButton className="px-2 py-1 text-base text-primary sm:text-xs" data-testid={`task-progress-save-${task.id}`}
                     onClick={() => onProgress(task, p)}>{t("tasks.actions.progress")}</NeuButton>
        </div>
      ) : null}
      <div className="flex flex-wrap items-center gap-1.5">
        {editable && canWork ? (
          <NeuButton className={`${btn} text-emerald-600`} data-testid={`task-complete-${task.id}`} onClick={() => onComplete(task)}>
            <Check className="h-3.5 w-3.5" /> {t("tasks.actions.complete")}
          </NeuButton>
        ) : null}
        {canManage && task.status === "pending_review" ? (
          <>
            <NeuButton className={`${btn} text-emerald-600`} data-testid={`task-approve-${task.id}`} onClick={() => onApprove(task)}>
              <Check className="h-3.5 w-3.5" /> {t("tasks.actions.approve")}
            </NeuButton>
            <NeuButton className={`${btn} text-rose-600`} data-testid={`task-reject-${task.id}`} onClick={() => onReject(task)}>
              <X className="h-3.5 w-3.5" /> {t("tasks.actions.reject")}
            </NeuButton>
          </>
        ) : null}
        {canManage && task.status !== "completed" ? (
          <NeuButton className={`${btn} text-sky-600`} data-testid={`task-edit-${task.id}`} onClick={() => onEdit(task)}>
            <Pencil className="h-3.5 w-3.5" /> {t("common.edit")}
          </NeuButton>
        ) : null}
        {canManage ? (
          <NeuButton className={`${btn} text-destructive`} data-testid={`task-delete-${task.id}`} onClick={() => onDelete(task)}>
            <Trash2 className="h-3.5 w-3.5" /> {t("common.delete")}
          </NeuButton>
        ) : null}
      </div>
    </div>
  );
};
